import { uploadEventList } from "$common/utils/event-tracking/page";
import { isWownowApp } from '$common/utils/common'
import storage from '$common/utils/storage';

export default {
  use: (Vue, Router, loadLanguageAsync) => {
    Vue.use(Router);
    const { routerPreFix } = require('$proDirname/prefix');
    //  设置 spa 的路由前缀
    const prefix = window?.ssrConfig?.routerConfig?.name ?? `/${routerPreFix.orderFood}/index`;

    const router = new Router({
      mode: 'history',
      prefix,
      routes: [
        {
          path: `*`,
          redirect: `${prefix}/store-info`
        },
        {
          name: 'store-info',
          path: `${prefix}/store-info`,
          component: resolve => import('./store-info').then(resolve)
        },
        {
          name: 'cart-info',
          path: `${prefix}/cart-info`,
          component: resolve => import('./cart-info').then(resolve)
        },
        {
          name: 'checkout-info',
          path: `${prefix}/checkout-info`,
          component: resolve => import('./checkout-info').then(resolve)
        },
        {
          name: 'order-detail',
          path: `${prefix}/order-detail`,
          component: resolve => import('./order-detail').then(resolve)
        },
        {
          name: 'order-list',
          path: `${prefix}/order-list`,
          component: resolve => import('./order-list').then(resolve)
        },
        {
          name: 'pay-result',
          path: `${prefix}/pay-result`,
          component: resolve => import('./pay-result').then(resolve)
        }
      ]
    });
    //  路由切换懒加载对应的国家化文案
    router.beforeEach((to, from, next) => {
      // 删除掉nomsg
      storage.remove('noMsg')
      if (to.name == 'checkout-info' && from.name == 'order-detail' && isWownowApp) {
        const versionStr = $vm?.wownowVersions
        console.log('versionStr', versionStr)
        let route = 'SuperApp://SuperApp/orderList'
        if (versionStr < '2.35.0') {
          route = 'SuperApp://SuperApp/YumNow'
        }
        window?.WOWNOW?.navigationToRoute({
          route
        });
        window?.WOWNOW?.closeWindow()
        return
      }
      // 变更为下单页时返回到门店后 记录
      if (to.name == 'store-info' && from.name == 'checkout-info') {
        uploadEventList([
          {
            businessName: "扫码点餐购物车返回门店",
            eventGroup: "other",
            event: "scan_cart_back"
          }
        ])
      }
      //  订单页
      // if (!isWownowApp && (to.name == 'order-list')) {
      //   const callbackUrl = window.location.href
      //   // 已登录 直接next
      //   if (storage.getItem('loginName') || storage.getItem('operatorNo')) {
      //     next()
      //     return
      //   } else {
      //     // 未登录 去到登录页
      //     if (process.env.NODE_ENV === 'development') {
      //       window.location.replace(`/super/app/user/v1/index/login?callback=${encodeURIComponent(callbackUrl)}`)
      //       return
      //     } else {
      //       window.location.replace(`/mobile-h5/super/app/user/v1/login?callback=${encodeURIComponent(callbackUrl)}`);
      //       return
      //     }
      //   }
      // }
      next()
    });
    return router;
  }
};
